import template from '../../../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../../../ui-formly/controllers/FormControllerFactory'
import { vsName as CommonMachineServerName } from '../../../../Server'
import fields from './formly'

export const vsName = 'machineDecommission'
export const vsNgType = 'directive'

machineDetailDecommission.$inject = [CommonMachineServerName]
export function machineDetailDecommission(CommonMachineServer) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '='
    },
    controller: FormControllerFactory({
      returnState: '^.configurations',
      formFields: fields(CommonMachineServer),
      submit: CommonMachineServer.machineDecommission
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}